module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-detail-item"
  }, [(_vm.title) ? _c('div', {
    staticClass: "detail-item-header"
  }, [_c('div', {
    staticClass: "detail-item-icon"
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.icon,
      "size": 18
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "detail-item-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "detail-item-btns"
  }, [_vm._t("btn")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-item-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-251ef803"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/detail/rtDetailItem.vue
// module id = 2090
// module chunks = 137